G.TextRTCacher = function(){

};

G.TextRTCacher.prototype.cacheText = function(font,txt,fontSize,cacheLabel,tint){

	if (!this.txt){
		this.txt = game.make.bitmapText(0,0,font,'',80);
	}

	this.txt.fontSize = fontSize;
	this.txt.setText(txt);
	this.txt.tint = tint || 0xffffff;
	this.txt.updateCache();

	var rt = game.make.renderTexture(this.txt.width,this.txt.height,cacheLabel,true);
	rt.render(this.txt);

};

G.TextRTCacher.prototype.cachePhaserText = function(text,cacheLabel,style){

	var txt = game.make.text(0,0,text,style);
	var rt = game.make.renderTexture(txt.width,txt.height,cacheLabel,true);
	rt.render(txt);
	txt.destroy();

};